var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noNewsData keep-hue",class:{'module': _vm.type === 'module', 'center': _vm.type === 'center'}},[_c('img',{attrs:{"src":require("@/assets/Service/noneT@2x.svg")}}),_c('p',[_vm._v("没有相关内容")])])}
var staticRenderFns = []

export { render, staticRenderFns }